import ApiService from "../api/api.service";

/*------------------------------------*\
    Action Constants
\*------------------------------------*/
import {
    GET_EVENTS,
    GET_SEASON_EVENTS
} from "../store/actions.type";

/*------------------------------------*\
    Mutation Constants
\*------------------------------------*/
import {
    CLEAR_ERRORS,
    SET_ERROR,
    CLEAR_EVENTS,
    SET_EVENTS
} from "../store/mutations.type";

/*------------------------------------*\
    State
\*------------------------------------*/
const getDefaultState = () => {
    return {
        events: [],
        loading: true,
        errors: {
            events: [],
        }
    }
};

const state = getDefaultState();

/*------------------------------------*\
    Getters
\*------------------------------------*/
const getters = {
    getEvents(state) {
        return state.events;
    },
    getLoading(state) {
        return state.loading;
    },
};

/*------------------------------------*\
    Mutations
\*------------------------------------*/
const mutations = {
    [CLEAR_EVENTS](state) {
        state.loading = true;
        state.events = [];
    },
    [SET_EVENTS](state, data) {
        state.loading = false;
        state.events = data;
    },
};

/*------------------------------------*\
    Actions
\*------------------------------------*/
const actions = {
    [GET_EVENTS](context, params) {
        //context.commit(CLEAR_EVENTS);
        return new Promise((resolve, reject) => {
            ApiService.get("/events", params)
                .then(({
                    data
                }) => {
                    if (true) {
                        context.commit(CLEAR_ERRORS);
                        context.commit(
                            SET_EVENTS, data
                        );
                    }
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'events',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
    [GET_SEASON_EVENTS](context, params) {
        context.commit(CLEAR_EVENTS);
        return new Promise((resolve, reject) => {
            ApiService.get("/season", params)
                .then(({
                    data
                }) => {
                    if (true) {
                        context.commit(CLEAR_ERRORS);
                        context.commit(
                            SET_EVENTS, data
                        );
                    }
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'events',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
};

export default {
    getters,
    actions,
    mutations,
    state
}
